import VOrder from "./VOrder"
import Item from "./Item"

VOrder.Item = Item;

export default VOrder;
